import BaseService from './BaseService';

class NewsService extends BaseService {
  /**
   * Fetch
   * @return {Promise} [description]
   */
  fetch = () => {
    const config = {
      url: '/news',
    };
    return this.doRequest(config);
  }
}

export { NewsService as default };
